import { render } from "./Slideover.vue?vue&type=template&id=c0e83632"
import script from "./Slideover.vue?vue&type=script&lang=js"
export * from "./Slideover.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__